<template>
  <a
    :href="post.href"
    class="blog-post-card"
    :class="[`blog-post-card--${size}`, { 'blog-post-card--large': large }]"
  >
    <div class="blog-post-card-media">
      <img :src="post.image" :alt="post.title" loading="lazy" class="blog-post-card-img"/>
      <template v-if="size === 'bento'">
        <div class="blog-post-card-scrim"></div>
        <div class="blog-post-card-overlay-body">
          <span v-if="post.category" class="blog-post-card-category">{{ post.category }}</span>
          <h3 class="blog-post-card-title">{{ post.title }}</h3>
        </div>
      </template>
    </div>
    <div v-if="size !== 'bento'" class="blog-post-card-body">
      <h3 class="blog-post-card-title">{{ post.title }}</h3>
      <p class="blog-post-card-excerpt">{{ post.excerpt }}</p>
      <div class="blog-post-card-meta">
        <span class="blog-post-card-author">{{ post.author }}</span>
        <span class="blog-post-card-dot">&bull;</span>
        <span class="blog-post-card-date">{{ formattedDate }}</span>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'BlogPostCard',
  props: {
    post: { type: Object, required: true },
    size: { type: String, default: 'grid', validator: (value) => ['grid', 'bento'].includes(value) },
    large: { type: Boolean, default: false },
  },
  computed: {
    formattedDate: function() {
      const [year, month, day] = this.post.date.split('-')
      return `${day}/${month}/${year}`
    },
  },
}
</script>

<style scoped>
.blog-post-card {
  display: block;
  text-decoration: none;
  color: inherit;
  background: #FFFFFF;
  border-radius: 1.25rem;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(16,24,39,0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.blog-post-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 28px rgba(16,24,39,0.09);
}
.blog-post-card-media {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: #F0EEE6;
}
.blog-post-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.blog-post-card-body {
  padding: 1.25rem 1.5rem 1.5rem;
}
.blog-post-card-title {
  font-weight: 800;
  color: #101827;
  margin: 0 0 0.5rem;
  line-height: 1.3;
}
.blog-post-card--grid .blog-post-card-title {
  font-size: 1.05rem;
}

/* Bento variant: full-bleed image with a dark scrim and overlaid title */
.blog-post-card--bento {
  position: relative;
  height: 100%;
}
.blog-post-card--bento .blog-post-card-media {
  height: 100%;
  aspect-ratio: unset;
}
.blog-post-card-scrim {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(16,24,39,0) 40%, rgba(16,24,39,0.82) 100%);
}
.blog-post-card-overlay-body {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 1.25rem 1.4rem 1.4rem;
}
.blog-post-card-category {
  display: block;
  color: #4FC3F7;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
}
.blog-post-card--bento .blog-post-card-title {
  color: #FFFFFF;
  font-size: 1.05rem;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.blog-post-card--bento.blog-post-card--large .blog-post-card-title {
  font-size: 1.5rem;
}
@media (max-width: 959px) {
  .blog-post-card--bento .blog-post-card-media {
    height: auto;
    aspect-ratio: 16 / 9;
  }
}
.blog-post-card-excerpt {
  color: #5B6472;
  font-size: 0.92rem;
  line-height: 1.6;
  margin: 0 0 0.9rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.blog-post-card-meta {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: #8892A0;
  font-size: 0.8rem;
}
.blog-post-card-dot {
  opacity: 0.6;
}
</style>
